import { Controller } from "@hotwired/stimulus"

const CONFETTI_COUNT = 40
const CONFETTI_COLORS = ["--bs-primary", "--bs-success", "--bs-warning", "--bs-info", "--bs-danger"]

// Fin du parcours « Premiers pas » : confettis + invitation à explorer le reste de l'Académie.
export default class extends Controller {
  static targets = ["confetti"]

  connect() {
    // Même raison que `modal_controller` : un ancêtre transformé casserait le position: fixed.
    if (this.element.parentElement !== document.body) {
      document.body.appendChild(this.element)
      return
    }

    this.boundOpen = this.open.bind(this)
    this.boundOnKeydown = this.onKeydown.bind(this)
    document.addEventListener("academy-onboarding:completed", this.boundOpen)
  }

  disconnect() {
    if (this.boundOpen) document.removeEventListener("academy-onboarding:completed", this.boundOpen)
    if (this.boundOnKeydown) document.removeEventListener("keydown", this.boundOnKeydown)
    window.clearTimeout(this.hideTimeout)
  }

  open() {
    window.clearTimeout(this.hideTimeout)
    this.spawnConfetti()

    this.element.classList.remove("d-none")
    this.element.setAttribute("aria-hidden", "false")
    window.requestAnimationFrame(() => {
      this.element.classList.add("academy-onboarding-celebration--visible")
    })

    document.addEventListener("keydown", this.boundOnKeydown)
  }

  close() {
    this.element.classList.remove("academy-onboarding-celebration--visible")
    document.removeEventListener("keydown", this.boundOnKeydown)

    this.hideTimeout = window.setTimeout(() => {
      this.element.classList.add("d-none")
      this.element.setAttribute("aria-hidden", "true")
      if (this.hasConfettiTarget) this.confettiTarget.replaceChildren()
    }, 240)
  }

  onKeydown(event) {
    if (event.key === "Escape") this.close()
  }

  explore(event) {
    const { paneId } = event.currentTarget.dataset
    this.close()
    document.querySelector(`[data-bs-target="#${paneId}"]`)?.click()
  }

  spawnConfetti() {
    if (!this.hasConfettiTarget) return
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return

    const pieces = Array.from({ length: CONFETTI_COUNT }, (_piece, index) => {
      const confetti = document.createElement("span")
      confetti.className = "academy-onboarding-celebration__confetti-piece"
      if (index % 3 === 0) confetti.classList.add("academy-onboarding-celebration__confetti-piece--round")

      confetti.style.left = `${Math.random() * 100}%`
      confetti.style.backgroundColor = `var(${CONFETTI_COLORS[index % CONFETTI_COLORS.length]})`
      confetti.style.animationDelay = `${(Math.random() * 0.7).toFixed(2)}s`
      confetti.style.animationDuration = `${(1.8 + Math.random() * 1.4).toFixed(2)}s`
      confetti.style.setProperty("--academy-confetti-drift", `${Math.round((Math.random() - 0.5) * 240)}px`)
      confetti.style.setProperty("--academy-confetti-spin", `${Math.round(360 + Math.random() * 720)}deg`)

      return confetti
    })

    this.confettiTarget.replaceChildren(...pieces)
  }
}
